import { useEffect } from "react";
import useFetchJson from "../../../data/useFetchJson";
import { Grid } from "@mui/material";
import { DlspFieldFileUploadPanel } from "./DlspFieldFileUploadPanel";
import { ReactHooksFormWrapper, TextAreaRequiredControl } from "@northpowerdev/np-react-utils";
import { useForm } from "react-hook-form";
import { RadioGroupRequiredControl } from "../../styled/RadioGroupControl";


const initialFormState = {
    fieldInspectionComplete: null,                 // 'Yes' | 'No'
    fieldInspectionPriority: null,                 // 'Yes' | 'No'
    fieldInspectionComments: '',                   // 'free text'
}

const yesNoOptions = [
    {key: 'yes', value: 'Yes', label: 'Yes'},
    {key: 'no',  value: 'No',  label: 'No'},
]

export function DlspFieldInspectionForm({icpNumber, inspectionDetails, fieldPhotosRequired, desktopQABy, desktopQAComments, onClose}) {

    const { handleSubmit, control, formState: { errors }, setValue, /* watch, reset, getValues, trigger */ } = useForm({defaultValues: initialFormState});

    useEffect(() => {
        //
        // Triggers on start-up or task details change to pre-fill form fields
        // 
        if (inspectionDetails) {
            setValue('fieldInspectionComplete',  inspectionDetails.fieldInspectionComplete)
            setValue('fieldInspectionPriority',  inspectionDetails.fieldInspectionPriority)
            setValue('fieldInspectionComments',  inspectionDetails.fieldInspectionComments)
        }
    }, [inspectionDetails, setValue])

    const {
        isLoading: fieldInspectionSaving,
        load: saveFieldInspection,
        } = useFetchJson('/bff/decommissioned-lines-service/api/decommissioned-lines/submit-field-inspection', {params: {icp: icpNumber}, method: 'POST'}) 


    const onSubmit = async (data) => {
        console.log('DlspTaskFieldInspection onSubmit data', data)
        const desktopAssessmentOptions = {
            body: JSON.stringify(data)
        }

        const theResponse = await saveFieldInspection(desktopAssessmentOptions)
        if (theResponse !== undefined) {
            onClose() // tell parent component we're done
        }
    }

    return (

        <Grid container spacing={2}>
            <Grid item xs={12}>
                <DlspFieldFileUploadPanel icp={icpNumber} fieldPhotosRequired={fieldPhotosRequired} desktopQABy={desktopQABy} desktopQAComments={desktopQAComments} />
            </Grid>
            <Grid item xs={12} sm={6}>
                <ReactHooksFormWrapper
                        onSubmit={handleSubmit(onSubmit)}
                        control={control}
                        errors={errors}
                        submitLabel="Save Field Inspection"
                        isSubmitting={fieldInspectionSaving}
                        submittingLabel="Saving field inspection..."
                >

                    <RadioGroupRequiredControl control={control} errors={errors} fieldName={'fieldInspectionComplete'}
                        fieldLabel="Field Inspection is Complete" controlSx={{my: 2}} options={yesNoOptions}
                    /> <br />

                    <RadioGroupRequiredControl control={control} errors={errors} fieldName={'fieldInspectionPriority'}
                        fieldLabel="Priority For Field QA" controlSx={{my: 2}} options={yesNoOptions}
                    /> <br />

                    <TextAreaRequiredControl control={control} errors={errors} fieldName={'fieldInspectionComments'}
                        fieldLabel="Field Inspection Comments" controlSx={{width: '100%', mb: 2}}
                        minRows={3} maxRows={3}
                    /> <br />
                </ReactHooksFormWrapper>
            </Grid>
        </Grid>

    )
}